// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="-1849 -3094.4 10 0.8"><path className="a" d="M-1849-3093.6v-.8h10v.8z"/></svg>
);

export default fn;
